import React from 'react'
import {
  CustomExpenseOption,
  ExpenseInfo,
  PurchaseOptions,
} from '../components'
import { useAccount } from 'src/hooks'

interface AddExpenseProps {
  setExpenseAmount: (amount: number) => void
  setIsExpenseAdded: (value: boolean) => void
  isExpenseAdded: boolean
}

const AddExpenseContainer: React.FC<AddExpenseProps> = props => {
  const { setExpenseAmount, setIsExpenseAdded, isExpenseAdded } = props

  const account = useAccount()

  const handleSelect = (amount: number) => {
    setExpenseAmount(amount)
    setIsExpenseAdded(!isExpenseAdded)
  }

  return (
    <PurchaseOptions
      title="Add Expense"
      subtitle="Expense pays for postage, shipping costs, and gift cards."
      isExpenseContainer={true}
      kind="expense"
      amount={account.expense.amount / 100}
    >
      <CustomExpenseOption
        onAdd={handleSelect}
        isSelected={isExpenseAdded}
        setExpenseAmount={setExpenseAmount}
      />
      <ExpenseInfo />
    </PurchaseOptions>
  )
}

export default AddExpenseContainer
